var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvocado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.281 5.18419C12.8611 6.01536 13.7777 6.65718 14.7829 6.78699C16.292 6.98185 17.7507 7.65886 18.9099 8.81802C21.6967 11.6048 21.6967 16.1231 18.9099 18.9099C16.1231 21.6967 11.6048 21.6967 8.81802 18.9099C7.65886 17.7507 6.98185 16.292 6.78699 14.7829C6.65718 13.7777 6.01536 12.8611 5.18419 12.281C4.94123 12.1114 4.70974 11.9182 4.49293 11.7014C2.50236 9.71085 2.50236 6.4835 4.49293 4.49293C6.4835 2.50236 9.71085 2.50236 11.7014 4.49293C11.9182 4.70974 12.1114 4.94123 12.281 5.18419ZM16.1213 16.1213C17.2929 14.9497 17.2929 13.0503 16.1213 11.8787C14.9497 10.7071 13.0503 10.7071 11.8787 11.8787C10.7071 13.0503 10.7071 14.9497 11.8787 16.1213C13.0503 17.2929 14.9497 17.2929 16.1213 16.1213Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvocado);
export default __webpack_public_path__ + "static/media/avocado.da1edbc7211be8fc285fe3a14b140f03.svg";
export { ForwardRef as ReactComponent };